// extracted by mini-css-extract-plugin
export default {"inForm":"styles_inForm__BUuGr","languageSwitcher":"styles_languageSwitcher__MEAi3","activeLabel":"styles_activeLabel__UVlj0","inactiveLabel":"styles_inactiveLabel__yPyUG"};